export const labels = {
	title: {
		label: "Label.MobileCreator.Sidebar.FontFamilies.Title",
		default: "Font",
	},
	recommendedFonts: {
		label: "Label.MobileCreator.Sidebar.FontFamilies.RecommendedFonts",
		default: "Recommended fonts",
	},
	allFonts: {
		label: "Label.MobileCreator.Sidebar.FontFamilies.AllFonts",
		default: "All fonts",
	},
};
